/**
 * 创建人：王靖
 * 时间：2019-6-14
 * 描述：下拉树组件
 * 使用说明: 参考 sw-tree-select 配置应用说明文档
 * 更新记录: 
 * 1.新增输入属性 readonlyNodeId ,yuanjs by 2019-8-9
 * 2.新增输入属性 heigjt ,yuanjs by 2019-8-12
 */
import { Component, OnInit, Input, forwardRef, ElementRef, Output, EventEmitter, ComponentFactoryResolver, Injector, ApplicationRef, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { SwTreeSelectBoxComponent } from './sw-tree-select-box/sw-tree-select-box.component';

export const EXE_COUNTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SwTreeSelectComponent),
  multi: true
};

/**
 * 下拉树组件  sw-tree-select
 */
@Component({ 
  selector: 'sw-tree-select',
  templateUrl: './sw-tree-select.component.html',
  styleUrls: ['./sw-tree-select.component.css'],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})
export class SwTreeSelectComponent implements ControlValueAccessor,OnInit {

  /**
   * 树绑定数据 格式{"id": "1", "text": "content", "pid": "0"}
   */
  @Input() datas: any[];  

  /**
   * 不要展示的节点(包括其子节点)的id
   */
  @Input() disabledNodeId:string = "";

  /**
   * 能展示但是不能选择的节点(包括其子节点)的id
   */
  @Input() readonlyNodeId:any[] = []  

  /**
   * 能展示但是不能选择的节点(不包括其子节点)的id
   */
  @Input() readonlySelfId:any[]  = []

  /**
   * 是否显示清除按钮
   */
  @Input() clearData: boolean = true;    

  /**
   * 禁用
   */
  @Input() disabled:boolean =false;  
  
  /**
   * 绑定的参数 保存的参数值
   */
  @Input() value:string ="id"  

  /**
   * 下拉框固定高度
   */
  @Input() height:string ="250px" 

  /**
   * 下拉树单选功能选中后展示效果,比如: 选中'墨葡科技' 后,input输入框中展示: '组织 > 数文科技 > 墨葡科技'
   */
  @Input() showFather:boolean = false
 /**
   * 下拉树单选功能选中后展示效果,比如: 选中'墨葡科技' 后,input输入框中展示: '组织 > 数文科技 > 墨葡科技'
   */
  @Input() returnfull:boolean = false

  /**
   * 下拉树未选择时 提示信息
   */
  @Input() placeholder:string = ''

  /**
   * 下拉树是否默认展开第一级节点， 默认不展开
   */
  @Input() isOneOpen:boolean = false
   /**
   * isPid0 在datas有值时，判断是否只显示根节点的pid和parentId为0的数据
   */
  @Input() isPid0: boolean=false;
  /**
   * 下拉树是否可以点击聚焦打开下拉树框  默认可以； 当为false时 不可以打开下拉框 常用于关联组织
   */
  @Input() isCanClick:boolean = true

   /**
   * 下拉树是否显示下拉图标  默认可以； 当为false时 不显示下拉图标 常用于关联组织
   */
  @Input() isShowIcon:boolean = true
  /**
   * 输出属性,将选中的节点抛出
   */
  @Output() changClick  = new EventEmitter();

  /**
    * 输出属性,清空后,将将清空值传递给父组件
    */
   @Output() clearClick = new EventEmitter();

  /**
   * 输入框
   */
  @ViewChild('input') input:ElementRef;

  /**
   *  @ignore
   *  展现关闭下拉
   */
  swTreeSelectComponentRef:any;

  /**
   * input显示内容
   * @ignore
   */
  text:string;  

  /**
   * 双向绑定id值
   * @ignore
   */
  _id: string;  
  
  parentArr:any[] = []

  /**
   * @ignore
   */
  get Id() {   
    return this._id;
  }

  /**
   * @ignore
   */
  set Id(value: string) {
    this._id = value;
    this.propagateChange(this._id);
  }

  /**
   * @ignore
   */
  propagateChange = (_: any) => {};

  /**
   * ngModeul 双向绑定数据
   * @ignore
   * @param value 
   */
  writeValue(value: string): void {
    if (value) {
      this.Id = value;
      if(this.datas){
        let node = this.datas.filter(x => x[this.value]==value);
        //如果绑定返回值为id
        if(this.value == 'id') {
          if (node.length>0) {
            this.Id = node[0].id;
            this._id = node[0].id;
            if(this.showFather){    //如果指定了输入框的展示效果,就要对text进行处理再展示
              this.parentArr = [node[0]]
              this.findFarent(node[0])
              let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
              textArr = textArr.reverse()
              this.text = textArr.join(' > ')


         

            } else {
              this.text = node[0].text;
            }
            
          }
        }else{
          //绑定返回值不为id
          if (node.length>0) {
            this.Id = node[0][this.value];
            this._id = node[0][this.value];
            if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
              this.parentArr = [node[0]]
              this.findFarent(node[0])
              let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
              textArr = textArr.reverse()
              this.text = textArr.join(' > ')




            } else {
              this.text = node[0].text;
            }
            
          }
        }
      }
    
    }
    else{
      this._id = value;
      this.text = "";
    }
  }

  /**
   * @ignore
   * @param node,该参数可能是 datas中的数据,还是 id,pid,text这个格式,页可能是选中之后传来的node,是key,parent,title这样的格式,处理时需要注意,但是获取到的父节点的数据格式都是前者
   */
  
  findFarent(node: any): void {
    let pid = node.pid || node.parent
    if(pid){
      let p = this.datas.filter(x => x.id==pid)
      if(p.length){
        this.parentArr.push(p[0])
        if(p[0].pid){
          this.findFarent(p[0])
        }
      }
    }
  }


  /**
   * @ignore
   * @param fn 
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  /**
   * @ignore
   * @param fn 
   */
  registerOnTouched(fn: any): void {
  }

  /**
   * @ignore
   * @param isDisabled 
   */
  setDisabledState?(isDisabled: boolean): void {
  }

  /**
   * 定位width
   * @ignore
   */
  width:string

  /**
   * 定位left
   * @ignore
   */
  left:string
  
  /**
   * 定位top
   * @ignore
   */
  top:string

  /**
   * 唯一主键
   * @ignore
   */
  ids:string

  /**
   * @ignore
   * @param el 
   * @param componentFactoryResolver 
   * @param injector 
   * @param applicationRef 
   */
  constructor(
    private el :ElementRef,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private applicationRef: ApplicationRef,) { }

  /**
   * @ignore
   */
  ngOnInit() { }

  /**
   * 开启或关闭下拉框
   * @ignore
   */
  dropdown: boolean = false;

  /**
   * 打开选中框
   * @param event
   * @ignore 
   */
  open(event){
    if(this.isCanClick){
      const com = document.createElement(SwTreeSelectBoxComponent.name);
      //创建动态组件
      const factory = this.componentFactoryResolver.resolveComponentFactory(SwTreeSelectBoxComponent);
      this.swTreeSelectComponentRef = factory.create(this.injector, [], com);
      this.applicationRef.attachView(this.swTreeSelectComponentRef.hostView);
      // 弹出下拉框
      this.dropdown = true;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["ids"] = this.ids;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["elem"] = this.el;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["dropdown"] = this.dropdown;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["height"] = this.height;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["keySelected"] = this.Id;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["disabledNodeId"] = this.disabledNodeId;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["readonlyNodeId"] = this.readonlyNodeId;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["readonlySelfId"] = this.readonlySelfId;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["isOneOpen"] = this.isOneOpen;
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["datas"] = this.datas; 
      // 给组件传递参数
      this.swTreeSelectComponentRef.instance["isPid0"] = this.isPid0;
      // 给组件传递回调函数
      this.swTreeSelectComponentRef.instance["closeSelect"].subscribe(data => {
        // 失去焦点
        this.input.nativeElement.blur()
        if (data) {
          // 如果有参数传递出来，就执行回调
          this.voted(data);
        }
        try {
          // 移除dom
          document.body.removeChild(com);
          this.applicationRef.detachView(this.swTreeSelectComponentRef.hostView);
          // 销毁组件
          this.swTreeSelectComponentRef.destroy()
        } catch (e) { }
  
      });
      // 将组件追加到dom中去
      document.body.appendChild(com);
    }
  }

  /**
   * 关闭选中框
   * @ignore
   */
  close() {
    // this.dropdown = false;
    if(this.isCanClick){
      this.swTreeSelectComponentRef.instance.close()
    }
  }

  /**
   * 选择事件
   * @ignore
   * @param node 
   */
  voted(node){
    //设置id
    this.Id = node.data[this.value];
    //设置 text
    if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
      this.parentArr = []  //注意此处的node的格式是 key , parent, title这样的,与之后找到的父节点的格式不一样,所以单独处理
      this.findFarent(node)  //需要从datas中找到该节点的父节点
      let textArr = this.parentArr.map(v=>v.text)  //[选中项父节点,选中项祖节点]
      textArr = textArr.reverse()  //[选中项祖节点,选中项父节点]
      //将自己的节点的title加到数组中
      textArr.push(node.title)  //[选中项祖节点,选中项父节点,当前节点]
      this.text = textArr.join(' > ')


 if(this.returnfull)
 {
  let idArr = this.parentArr.map(v=>v.value)  //[选中项,选中项父节点,选中项祖节点]
  idArr = idArr.reverse()
  idArr.push(node.data[this.value])
  this.Id  = idArr.join('/')
  this._id =  idArr.join('/')

 }
     








    } else {
      this.text = node.title;
    }
    //设置抛出数据
    this.changClick.emit(node);
  }

  /**
   * 传递参数发生变化的时候触发
   * @ignore
   */
  ngOnChanges(){
    //放置先获取到选择数据
    //后获取到数据集的问题 
    //判断数据集合 选择数据都不为空的情况下选中数据
    if(this.datas ==null || this.datas == undefined)
      return;
      
    if(this.datas.length>0){
      if(this.Id!=null && this.Id!=undefined && this.Id!=""){
        let node = this.datas.filter(x => x[this.value]==this.Id);
        if (node.length>0) {
          this.Id = node[0][this.value];
          if(this.showFather){  //如果指定了输入框的展示效果,就要对text进行处理再展示
            this.parentArr = [node[0]]
            this.findFarent(node[0])
            let textArr = this.parentArr.map(v=>v.text)  //[选中项,选中项父节点,选中项祖节点]
            textArr = textArr.reverse()
            this.text = textArr.join(' > ')
          } else {
            this.text = node[0].text;
          }
          
        }
      }
    }
  }

  /**
   * 清空选中
   * @ignore
   */
  clearSelect(){
    this.Id = "";
    this.text ="";
    this.clearClick.emit(null)
  }

  //点击右侧三角图标
  //点击右侧三角图标
  switchDropmenu(event){
    event.stopPropagation(); //禁止冒泡
    if(!this.dropdown){ 
      //如果this.dropdown 为false,说明没有展开下拉框,此时需要展开下拉框
      this.input.nativeElement.focus()
    }  else {
      //此时已经自动触发了 blur 事件,下拉框已销毁, 需要将 this.dropdown 设置为false
      this.dropdown = false
    }
  }
}
